import { useQuery } from "@tanstack/react-query";
import { getCategoryById } from "../api";

export const useGetCategoryById = (id: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["CATEGORY", id],
    queryFn: () => getCategoryById(id),
    select: ({ data }) => data,
    enabled: !!id,
  });
  return { category: data, isLoading };
};
